import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const calculateHandymanServiceCost = (requestCriteria, serviceDate, startTime, endTime) => {
    return axios.post(api_url + "/public/CalculateHandymanServiceCost", {
            requestCriteria,
            serviceDate,
            startTime,
            endTime
        }, {
            headers: { "Content-Type": "application/json" }
        })
        .then(response => response.data)
        .catch(error => {
            console.error("Error calculating handyman service cost:", error);
            throw error;
    });
}

export const getHandymanPriceList = (country) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/public/GetHandymanPriceList",
          params : {"country" : country},
          headers:  { "Content-Type": "application/json"},
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}